<template>
  <a @click="scrollTop" v-show="visible" class="bottom-right z1">
    <button class="btn btn-info text-white">
      <i class="fa fa-angle-double-up"></i> {{$t('global.scrolltop')}}
    </button>
  </a>
</template>

<script>
  export default {
    name: 'ScrollTop',
    data () {
      return {
        visible: false
      }
    },
    mounted: function () {
      window.addEventListener('scroll', this.scrollListener)
    },
    beforeDestroy: function () {
      window.removeEventListener('scroll', this.scrollListener)
    },
    methods: {
      scrollTop: function () {
        this.intervalId = setInterval(() => {
          if (window.pageYOffset === 0) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 50)
        }, 20)
      },
      scrollListener: function (e) {
        this.visible = window.scrollY > 150
      }
    },
  };
</script>

<style scoped>
  .bottom-right {
    position: fixed;
    bottom: 12px;
    right: 12px;
    cursor: pointer;
  }
  .z1{

    z-index: 10;
  }
</style>

